import {
  createFileRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import React from "react";

const PAGE_TITLES: Record<string, string> = {
  "/login": "Log In - SalesTrak",
  "/register": "Sign Up - SalesTrak",
  "/forgot-password": "Forgot Password - SalesTrak",
  "/reset-password": "Reset Password - SalesTrak",
  "/reset-password-sent": "Check Your Email - SalesTrak",
  "/verify-email": "Verify Your Email - SalesTrak",
  "/verify-email-sent": "Check Your Email - SalesTrak",
  "/accept-invite": "Accept Invitation - SalesTrak",
};

function AuthLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  React.useEffect(() => {
    const title = PAGE_TITLES[pathname];
    if (title) document.title = title;
  }, [pathname]);

  return <Outlet />;
}

// The whole group is the front door: no one is signed in yet, so every screen
// under it wears the shipped appearance in the device's mode.
export const Route = createFileRoute("/(auth)")({
  component: AuthLayout,
  staticData: { standardAppearance: true },
});
